import { DoubleSide, MeshMatcapMaterial, MultiplyBlending, TextureLoader } from 'three';

function initGobeletMaterial() {
    const textureLoader = new TextureLoader();
    const matcapTexture = textureLoader.load('/models/textures/matcap-plastic.png');
    const bumptexture = textureLoader.load('/models/textures/T_noise_bump.webp');
    bumptexture.wrapS = bumptexture.wrapT = 1000; // Set wrap mode to repeat for better tiling
    bumptexture.repeat.set(3, 3); // Adjust repeat for better texture tiling

    // Matcap material with transparency - optimized for double-walled geometry
    return new MeshMatcapMaterial({
        matcap: matcapTexture,
        normalMap: bumptexture,
        transparent: true,
        opacity: 0.77,
        side: DoubleSide, // Render both sides to eliminate stripes
        alphaTest: 0.01, // Lower alpha test for better transparency
        depthWrite: false, // Disable depth writing to prevent z-fighting between walls
        depthTest: true, // Keep depth testing for proper occlusion
        polygonOffset: true, // Enable polygon offset to separate surfaces
        polygonOffsetFactor: -1, // Negative value to push surface forward
        polygonOffsetUnits: -1,
        blending: MultiplyBlending,
    });
}

export { initGobeletMaterial };
